import * as React from "react";

const SpeakerMuted = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#64748B"
      d="M11.689 2.587a.574.574 0 0 0-.605.063L6.067 6.552h-3.25a1.15 1.15 0 0 0-1.15 1.15v4.597a1.15 1.15 0 0 0 1.15 1.15h3.25l5.017 3.9a.575.575 0 0 0 .927-.452V3.104a.575.575 0 0 0-.322-.517ZM2.816 7.701H5.69V12.3H2.816V7.701Zm8.046 8.02-4.023-3.128V7.408l4.023-3.129v11.442Zm7.303-4.403a.575.575 0 1 1-.813.813l-1.318-1.318-1.317 1.318a.575.575 0 0 1-.814-.813L15.223 10l-1.319-1.317a.575.575 0 0 1 .814-.814l1.317 1.319 1.318-1.319a.575.575 0 1 1 .813.814L16.847 10l1.318 1.318Z"
    />
  </svg>
);
export default SpeakerMuted;
